import NearbyBuyersMachine from 'features/NearbyBuyers/machine/NearbyBuyersMachine/NearbyBuyersMachine'
import { ErrorLib } from 'libs/errors'
import { XStateLib } from 'libs/XStateLib'

const NearbyBuyersContext = XStateLib.createRuntimeActorContext(
  NearbyBuyersMachine.make().pipe(ErrorLib.tapCauseReporter),
)

export default NearbyBuyersContext
